export default [
    {
        path: '/signatures/type-process',
        name: 'signatures-type-process',
        component: () => import ('./views/TypeProcessIndex'),
        meta: {
            title: 'Tipos de processos para assinaturas',
            icon: 'mdi-animation-play',
            breadcrumbs: [
                { text: 'Lista de tipos de processos para assinaturas', disabled: true }
            ]
        }
    },
]
